import React from 'react'
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom'

import Home from './component/home/home.js'
import About from './component/about/about.js'
import Create from './component/create/create.js'

const App = () => (
  <Router>
    <div>
      <Route exact path="/" component={Home}/>
      <Route exact path="/sobre" component={About}/>
      <Route exact path="/cadastre" component={Create}/>
    </div>
  </Router>
)
export default App



// WEBPACK FOOTER //
// ./src/App.js